import { render, staticRenderFns } from "./infodisceat.vue?vue&type=template&id=654004e0&scoped=true"
import script from "./infodisceat.vue?vue&type=script&lang=js"
export * from "./infodisceat.vue?vue&type=script&lang=js"
import style0 from "./infodisceat.vue?vue&type=style&index=0&id=654004e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654004e0",
  null
  
)

export default component.exports